var exports = {
  "phone": "xa15a2ab7--35e617--phone",
  "phone-size-XS": "xa15a2ab7--35e617--phone-size-XS",
  "phone-size-M": "xa15a2ab7--35e617--phone-size-M",
};

module.exports = exports;
